<template>
    <div class="region-voiture-container page-container px-3 px-xl-0">
        <div class="container-xl ">
            <div class="pt-64 pb-64 text-center">
                <h2 class="title text-gray-900 pb-2">Trouver la Voiture d’Occasion Idéale en Tunisie</h2>
                <p class="text-gray-500 fsz-16 px-lg-224">
                    Découvrez notre plateforme régionale de voitures d’occasion en Tunisie.
                    Explorez les offres exclusives et trouvez la voiture parfaite près de chez vous, région par région.
                </p>
            </div>
            <div class="region-list pb-80 px-3">
                <div class="d-flex flex-wrap justify-content-center justify-content-lg-start">
                    <div class="region col-12 col-sm-5 col-lg-2 pb-3 pt-3" v-for="(city,index) in cities.sort((cityA, cityB) => cityA.name.localeCompare(cityB.name))" :key="index">
                        <span class="text-gray-400 me-2"><span v-if="index <= 8">0</span>{{ index +1  }} </span>
                        <NuxtLink 
                        :to=" {path : '/voitures/'+city.name  , query : {RG : city.name}}" 
                        class="text-primary-700 fsz-14 fw-medium">
                            {{city.name}}
                        </NuxtLink>

                    </div>
                    
                  </div>
            </div>

        </div>
    </div>
</template>

<script setup lang="ts">
import cities from "~/utils/tunisia_state.js";

const runTimeConfig = useRuntimeConfig();
const route = useRoute();

definePageMeta({
  layout: "terms-layout",
});

const seoUrl = ref();
const seoImage = ref();

const seoTitle = `Voitures d'occasion par région en Tunisie - TopAuto`;
const seoDescription = `Trouvez des voitures d'occasion dans votre région en Tunisie. Explorez les offres par ville et trouvez le véhicule idéal près de chez vous.`;
seoUrl.value = `${runTimeConfig.public.clientBaseUrl}${route.fullPath}`;
seoImage.value = `${runTimeConfig.public.clientBaseUrl}/_nuxt/assets/images/logos/Logo.png`;

useHead({
  title: seoTitle,
  link: [
    {
      rel: 'canonical',
      href: seoUrl
    }
  ],
  meta: [
    {
      name: 'description',
      content: seoDescription
    },
    {
      property: 'og:title',
      content: seoTitle
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:description',
      content: seoDescription
    },
    {
      property: 'og:url',
      content: seoUrl
    },
    {
      property: 'og:image',
      content: seoImage
    },
    {
      property: 'og:site_name',
      content: 'TopAuto'
    }
  ]
});

</script>

<style scoped>

</style>